import { ChangeEvent, useEffect, useState } from "react";
import { Button, Modal, Form, Col, Row } from "react-bootstrap";
import { FootModalProps } from "../interfaces/PatternView";
import Select from "./Select";
import { SelectOption } from "../interfaces/Toolbar";
import { loadFootCode } from "../services/Foot";


function FootModal(props: FootModalProps) {
  const [newTangentBodyPart, setNewTangentBodyPart] = useState<string>("");

  useEffect(() => {
    if (props.showModal) {
      setNewTangentBodyPart(props.pos!.tangentBodyPart);
    }
  }, [props.showModal]);

  const [selectedOption, setSelectedOption] = useState<number>(0);
  const [selectedOptions, setSelectedOptions] = useState<SelectOption[]>([]);
  
  function onSelectChange(e: ChangeEvent<HTMLSelectElement>) {
    setNewTangentBodyPart(selectedOptions[+e.currentTarget.value].label);
    setSelectedOption(+e.currentTarget.value);
  }

  const singleOptions = [
    { value: 0, label: "Body Center", key: "0" },
    { value: 1, label: "Left Foot", key: "1" },
    { value: 2, label: "Right Foot", key: "2" },
  ];

  const coupleOptions = [   
    { value: 0, label: "Couple Center", key: "0"},   
    { value: 1, label: "Gentleman Body Center", key: "1" },
    { value: 2, label: "Gentleman Left Foot", key: "2" },
    { value: 3, label: "Gentleman Right Foot", key: "3" },
    { value: 4, label: "Lady Body Center", key: "4"},
    { value: 5, label: "Lady Left Foot", key: "5" },
    { value: 6, label: "Lady Right Foot", key: "6"},
  ];

  useEffect(()=> {
    if (props.joint) {
      setSelectedOptions(coupleOptions);
    }else {
      setSelectedOptions(singleOptions);
    }
  }, [props.showModal])

  const width: number = 500;
  const height: number = 500;

  function isVisible(rightFoot: boolean) {

    if (["Left Foot", "Gentleman Left Foot", "Lady Left Foot"].includes(newTangentBodyPart)) {
      if (!rightFoot) return true;
    }else if (["Right Foot", "Gentleman Right Foot", "Lady Right Foot"].includes(newTangentBodyPart)) {
      if (rightFoot) return true;
    }else if (["Body Center", "Gentleman Body Center", "Lady Body Center", "Couple Center"].includes(newTangentBodyPart)) {
      return true;
    }

    return false;
  }


  function getColor(rightFoot: boolean) {
    
    const bodyPart = newTangentBodyPart;

    if (["Gentleman Left Foot", "Gentleman Right Foot", "Gentleman Body Center"].includes(bodyPart)) {
      return props.gentlemanColor;
    }else if (["Lady Left Foot", "Lady Right Foot", "Lady Body Center"].includes(bodyPart)) {
      return props.ladyColor;
    }else if (["Left Foot", "Right Foot", "Body Center"].includes(bodyPart)) {
      if (props.dancerId % 2 === 1) {
        return props.gentlemanColor;
      }else {
        return props.ladyColor;
      }
    }else if (bodyPart === "Couple Center") {
      return props.coupleColor;
    }

    return props.gentlemanColor;
  }

  function getBrush() {
    const candiates = [...props.brushSelectedDancers];
    if (candiates.length === 0) {
      for (let i=1; i<=2*props.numCouples; i++) {
        candiates.push(i);
      }
    } 
    return candiates;
  }

  function getCoupleAmount() {
    const candidates = getBrush();

    let count: number = 0;
    candidates.forEach(id => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      const isMale = ((id - 1) % 2 === 0);
      if (couple.joint && isMale) count++;
    });

    return count;
  }


  function getSingleAmount() {
    const candidates = getBrush();

    let count: number = 0;
    candidates.forEach(id => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      if (!couple.joint) count++;
    });

    return count;
  }


  function getGentlemanAmount() {
    const candidates = getBrush();

    let count: number = 0;
    candidates.forEach(id => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      const isMale = ((id - 1) % 2 === 0);
      if (!couple.joint && isMale) count++;
    });

    return count;
  }


  function getLadiesAmount() {
    const candidates = getBrush();

    let count: number = 0;
    candidates.forEach(id => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      const isMale = ((id - 1) % 2 === 0);
      if (!couple.joint && !isMale) count++;
    });

    return count;
  }

  function applyForCouples() {
    const candiates = getBrush();
    candiates.forEach(id => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      if (couple.joint) props.changeTangentBodyPart(props.selectedPattern, id, newTangentBodyPart);
    })
  }

  function applyForSingles() {
    const candiates = getBrush();
    candiates.forEach(id => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      if (!couple.joint) props.changeTangentBodyPart(props.selectedPattern, id, newTangentBodyPart);
    })
  }

  function applyForGentlemen() {
    const candiates = getBrush();
    candiates.forEach(id => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      const isMale = ((id - 1) % 2 === 0);
      if (!couple.joint && isMale) props.changeTangentBodyPart(props.selectedPattern, id, newTangentBodyPart);
    })
  }

  function applyForLadies() {
    const candiates = getBrush();
    candiates.forEach(id => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      const isMale = ((id - 1) % 2 === 0);
      if (!couple.joint && !isMale) props.changeTangentBodyPart(props.selectedPattern, id, newTangentBodyPart);
    })
  }

  function applyForSelected() {
    props.changeTangentBodyPart(props.selectedPattern,props.dancerId, newTangentBodyPart);
  }

  return (
    <Modal
      show={props.showModal}
      onHide={() => {
        props.setShowModal(false);
        if (props.setShowModalForPatternView) {
          props.setShowModalForPatternView(false);
        }

      }}
      onClick={(e: any) => {
        e.stopPropagation();
      }}
      onMouseDown={(e: any) => {
        e.stopPropagation();
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Set Point</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          id="modal-wrapper"
          style={{ width: width + "px", height: height + "px" }}
        >
          <svg id="orientation-vis" width="100%" height="100%">
            <g transform={`translate(${0.5*width-20}, ${height / 2})`}>
              {loadFootCode("translate(0,0)", 0.01, getColor(true), true, isVisible(true))}
              {loadFootCode("translate(0,0)", 0.01, getColor(false), false, isVisible(false))}
            </g>
          </svg>
        </div>
        <Form>
          {props.editingModeActive && <Select
              value={selectedOption}
              onChange={onSelectChange}
              options={selectedOptions}
              renderOnAllDevices={true}
            />}
          
        </Form>
      </Modal.Body>
      <Modal.Footer>

      {props.editingModeActive && !props.joint && (props.dancerId % 2 === 1)  &&(
            <Button
              variant="secondary"
              onClick={applyForGentlemen}
            >
              {`Apply for men (${getGentlemanAmount()})`}
            </Button>
          )}
        {props.editingModeActive && !props.joint && (props.dancerId % 2 === 0) && (
            <Button 
              variant="secondary"
              onClick={applyForLadies}
            >
              {`Apply for ladies (${getLadiesAmount()})`}
            </Button>
          )}
        {props.editingModeActive && !props.joint &&(
          <Button 
            variant="secondary"
            onClick={applyForSingles}
          >
            {`Apply for singles (${getSingleAmount()})`}
          </Button>
        )}

        {props.editingModeActive && props.joint &&(
          <Button
            variant="secondary"
            onClick={applyForCouples}
          >
            {`Apply for couples (${getCoupleAmount()})`}
          </Button>
        )}

        {props.editingModeActive && (
          <Button
            variant="primary"
            onClick={applyForSelected}
          >
            Apply
          </Button>
        )}




        {!props.editingModeActive && (
          <Button
            variant="secondary"
            onClick={() => {
              props.setShowModal(false);
              if (props.setShowModalForPatternView) {
                props.setShowModalForPatternView(false);
              }

            }}
          >
            Close
          </Button>
        )}





      </Modal.Footer>
    </Modal>
  );
}

export default FootModal;
